import React, { Component } from 'react'
import axios from 'axios'
import AuthHeader from '../handf/AuthHeader'
import PopUp from '../round/PopUp'
import Second from '../round/Second'
import { API_URL } from '../../ajax/config'
import './auth.css'
import { withRouter } from 'react-router-dom'
axios.defaults.baseURL = API_URL

class CheckMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      winHeight: window.innerHeight - 164,
      Mobile: '',
      OriginMobile: '',
      VrCode: '',
      VrCodeErrmsg: '',
      isEditMobile: false,
      UserType: null,
      PopUp: '',
      MessageTip: '',
      KeyToken: '',
    }
  }

  componentDidMount = function () {
    const KeyToken = sessionStorage.getItem('pendingLoginToken')
    if (!KeyToken) {
      this.props.history.replace('/login')
      return
    }
    this.setState({ KeyToken: KeyToken })
    const contentHeight = document.body.scrollHeight
    const winHeight = window.innerHeight
    this.setState({
      winHeight:
        contentHeight < winHeight ? winHeight - 164 : contentHeight - 164,
    })
    axios
      .get('user/basic_info', { headers: { Access_Token: KeyToken } })
      .then((res) => {
        if (res.data.errno === '200') {
          const User = res.data.data[0]
          this.setState({
            Mobile: User.mobile || '',
            OriginMobile: User.mobile || '',
            UserType: User.type,
          })
        }
      })
  }

  MobileChange(event) {
    this.setState({ Mobile: event.target.value })
  }

  VrCodeChange(event) {
    this.setState({ VrCode: event.target.value })
  }

  getHeaders = () => ({ Access_Token: this.state.KeyToken })

  GetVrCodeClick() {
    if (!this.state.Mobile) {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '请输入手机号！',
      })
      return
    }
    axios
      .post(
        'passport/sms_code',
        { mobile: this.state.Mobile, type: 3 },
        { headers: this.getHeaders() }
      )
      .then((res) => {
        if (res.data.errno === '200') {
          this.setState({ VrCodeErrmsg: res.data.errmsg })
        } else {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: res.data.errmsg,
          })
        }
      })
  }

  SecondBackChange = (event) => {
    if (event === 'Stop') {
      this.setState({ VrCodeErrmsg: '' })
    }
  }

  enterAfterVerify = () => {
    const KeyToken = this.state.KeyToken
    axios.get('user/basic_info', { headers: this.getHeaders() }).then((res) => {
      if (res.data.errno === '200') {
        const User = res.data.data[0]
        const expired = Math.round(new Date().getTime() + 1000 * 60 * 60 * 6)
        const tokenAuth = JSON.stringify({
          KeyToken: KeyToken,
          time: expired,
          user_name:
            User.type === 0
              ? User.real_name
              : User.type === 1
              ? User.org_name
              : 'ssr',
        })
        sessionStorage.setItem('tokenAuth', tokenAuth)
        sessionStorage.setItem('gameId', '')
        sessionStorage.removeItem('pendingLoginToken')
        const routesAddress = sessionStorage.getItem('routesAddress')
        const { history } = this.props
        if (!routesAddress || routesAddress === '') {
          history.push('/member')
        } else {
          sessionStorage.setItem('routesAddress', '')
          history.push(routesAddress)
        }
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.data.errmsg || '登录信息获取失败！',
        })
      }
    })
  }

  //点击修改手机号：进入可编辑状态
  EditMobileClick() {
    this.setState({
      isEditMobile: true,
      Mobile: '',
      VrCode: '',
      VrCodeErrmsg: '',
    })
  }

  //取消修改，恢复原手机号
  CancelEditMobileClick() {
    this.setState({
      isEditMobile: false,
      Mobile: this.state.OriginMobile,
      VrCode: '',
      VrCodeErrmsg: '',
    })
  }

  //修改手机号成功后，调用 up_check_state 决定是否登录
  afterUpdateMobile = () => {
    axios
      .post(
        'passport/up_check_state',
        {
          mobile: this.state.Mobile,
          smscode: this.state.VrCode,
        },
        { headers: this.getHeaders() }
      )
      .then((res) => {
        if (res.data.errno === '200') {
          this.enterAfterVerify()
        } else {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: res.data.errmsg,
          })
        }
      })
  }

  SubmitClick() {
    if (!this.state.Mobile || !this.state.VrCode) {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '请填写手机号和验证码！',
      })
      return
    }

    if (this.state.isEditMobile) {
      axios
        .post(
          'user/update_mobile',
          {
            mobile: this.state.Mobile,
            smscode: this.state.VrCode,
          },
          { headers: this.getHeaders() }
        )
        .then((res) => {
          if (res.data.errno === '200') {
            this.afterUpdateMobile()
          } else {
            this.setState({
              PopUp: '提示弹窗',
              MessageTip: res.data.errmsg,
            })
          }
        })
      return
    }

    // 原手机号验证流程
    axios
      .post(
        'passport/sms_check',
        {
          mobile: this.state.Mobile,
          smscode: this.state.VrCode,
        },
        { headers: this.getHeaders() }
      )
      .then((res) => {
        if (res.data.errno !== '200') {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: res.data.errmsg,
          })
          return
        }
        axios
          .post(
            'passport/up_check_state',
            {
              mobile: this.state.Mobile,
              smscode: this.state.VrCode,
            },
            { headers: this.getHeaders() }
          )
          .then((upRes) => {
            if (upRes.data.errno === '200') {
              this.enterAfterVerify()
            } else {
              this.setState({
                PopUp: '提示弹窗',
                MessageTip: upRes.data.errmsg,
              })
            }
          })
      })
  }

  ChildBackTip = (event) => {
    if (event === 'CrossOut' || event === 'Confirm') {
      this.setState({ PopUp: '' })
    }
  }

  BackLoginClick() {
    sessionStorage.removeItem('pendingLoginToken')
    this.props.history.push('/login')
  }

  render() {
    return (
      <div className={'AuthBox'}>
        <AuthHeader />
        <div className={'AuthBg'} style={{ height: this.state.winHeight }}>
          <div
            className={'AuthBgColor'}
            style={{ height: this.state.winHeight }}
          >
            {' '}
          </div>
          <div className={'LoginAndForgetBox'}>
            <div className={'LoginAndForgetLogo'}>
              <div className={'FSLogo'}> </div>
              <div className={'FSTitle'}>会员中心</div>
            </div>
            <div className={'LoginAndForgetContent'}>
              <div className={'ForgetTitle'}>
                <div className={'ForgetTitleCenter'} style={{ width: 160 }}>
                  <div className={'ForgetTitleIco'}> </div>
                  <div className={'ForgetTitleWord'}>手机号验证</div>
                </div>
                <div
                  style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: '14px 20px 0',
                    textAlign: 'center',
                    fontSize: 18,
                    lineHeight: '26px',
                    letterSpacing: '0.04em',
                    fontWeight: 600,
                    color: '#F56C6C',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {this.state.isEditMobile
                    ? '请输入新手机号并获取验证码完成修改'
                    : '当前账号手机号未通过校验，请先完成验证'}
                </div>
                <div className={'ForgetStepOne'} style={{ marginTop: 32 }}>
                  <input
                    className={'PhoneInput'}
                    type={'text'}
                    name={'Mobile'}
                    value={this.state.Mobile}
                    onChange={this.MobileChange.bind(this)}
                    placeholder={
                      this.state.isEditMobile
                        ? '请输入新手机号'
                        : '请输入手机号'
                    }
                    autoComplete={'off'}
                    readOnly={!this.state.isEditMobile}
                    style={
                      !this.state.isEditMobile
                        ? { backgroundColor: '#f5f5f5', cursor: 'default' }
                        : {}
                    }
                  />
                  <div className={'ForgetCodeBox'}>
                    <input
                      className={'ForgetCodeInput'}
                      type={'text'}
                      name={'VrCode'}
                      value={this.state.VrCode}
                      onChange={this.VrCodeChange.bind(this)}
                      placeholder={'请输入验证码'}
                      autoComplete={'off'}
                    />
                    {this.state.VrCodeErrmsg === '' && (
                      <button
                        className={'ForgetCodeBtn'}
                        onClick={this.GetVrCodeClick.bind(this)}
                      >
                        获取验证码
                      </button>
                    )}
                    {this.state.VrCodeErrmsg !== '' && (
                      <button
                        className={'ForgetCodeBtn'}
                        style={{ backgroundColor: '#D5D5D5' }}
                      >
                        <Second
                          SecondBackChange={this.SecondBackChange.bind(this)}
                        />
                        <span style={{ width: 'auto', float: 'right' }}>
                          成功
                        </span>
                      </button>
                    )}
                  </div>
                  <button
                    className={'ForgetStepBtn'}
                    onClick={this.SubmitClick.bind(this)}
                  >
                    {this.state.isEditMobile ? '确认修改并进入' : '验证并进入'}
                  </button>
                  {!this.state.isEditMobile && (
                    <div
                      className={'ReturnLogin'}
                      style={{ marginTop: 14, color: '#F56C6C' }}
                      onClick={this.EditMobileClick.bind(this)}
                    >
                      修改手机号
                    </div>
                  )}
                  {this.state.isEditMobile && (
                    <div
                      className={'ReturnLogin'}
                      style={{ marginTop: 14 }}
                      onClick={this.CancelEditMobileClick.bind(this)}
                    >
                      取消修改
                    </div>
                  )}
                  <div
                    className={'ReturnLogin'}
                    style={{ marginTop: 14 }}
                    onClick={this.BackLoginClick.bind(this)}
                  >
                    返回登录
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default withRouter(CheckMobile)
